import { Box, CircularProgress } from "@mui/material";

/**
 * Loading Page
 * @param param0 
 * @returns 
 */
export const Loading = ({
  appBarOffset = 65,
  additionalOffset
}: {
  appBarOffset?: number,
  additionalOffset?: number
}) => {
  const offsetNumber = (appBarOffset ?? 0) + (additionalOffset ?? 0);
  const offsetPixels = `${offsetNumber}px`
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: `calc(50vh - ${offsetPixels})`
  }}>
    <CircularProgress />
  </Box>
}